import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom'; // Import Link if using React Router

const Solutions = () => {
  const [showVideo, setShowVideo] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const modalRef = useRef(null);

  const openVideo = (url) => {
    setVideoUrl(url);
    setShowVideo(true);
    document.body.style.overflow = 'hidden';
  };

  const closeVideo = () => {
    if (modalRef.current) {
      modalRef.current.style.transform = 'rotateY(90deg) scale(0.5)';
      modalRef.current.style.opacity = '0';
    }
    
    setTimeout(() => {
      setShowVideo(false);
      setVideoUrl("");
      document.body.style.overflow = 'auto';
    }, 300);
  };

  return (
    <div className="relative  md:pb-3 pb-2">
      {/* Background Layer */}
      <div className="absolute top-0 left-0 w-full h-4/5 bg-[#152C24] z-0"></div>

      {/* Content */}
      <div className="relative z-10 px-4 md:pr-20  md:pl-[120px] -mt-6 md:-mt-4 ">
        {/* Heading */}
        <div className="flex justify-between items-center md:px-4 mb-2">
          <h1 className="text-[12px] md:text-[40px] font-bold text-[#FDBD26] tracking-wide">
          Experience Farmnet App
          </h1>
          <img 
            src='https://res.cloudinary.com/dzngpgki4/image/upload/v1750713553/image_1_rzmlti.png' 
            alt='' 
            className='md:w-[150px] md:h-[50px] w-[50px] h-[14px]'
          />
        </div>

        {/* Image Box with Icons */}
        <div className="bg-[#2E453D] rounded-sm md:rounded-md w-full relative overflow-hidden">
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751106009/image_8_rahviu.png"
            className="md:h-[700px] w-full object-cover"
            alt="Experience"
          />

          {/* Left Arrow */}
          <div className="absolute left-4 top-1/2 transform -translate-y-1/2 z-20">
            <img
              src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759075131/Arrow_drop_left_xbnwv3.png"
              alt="Previous"
              className="md:w-[65px] w-[20px] h-[20px]  md:h-[65px] cursor-pointer hover:opacity-80 transition-opacity"
            />
          </div>

          {/* Right Arrow */}
          <div className="absolute right-4 top-1/2 transform -translate-y-1/2 z-20">
            <img
              src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759075131/Arrow_drop_left-1_gnp5sq.png"
              alt="Next"
              className="md:w-[65px] w-[20px] h-[20px]  md:h-[65px]  cursor-pointer hover:opacity-80 transition-opacity"
            />
          </div>

          {/* Center Play Icon with hover animation */}
          <div className="absolute inset-0 flex items-center justify-center z-30">
            <div 
              onClick={() => openVideo("https://res.cloudinary.com/dzngpgki4/video/upload/v1751293088/WhatsApp_Video_2025-06-29_at_6.11.16_PM_1_ls1egq.mp4")}
              className="cursor-pointer group"
            >
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                alt="Play Icon"
                className="w-[50px] h-[50px] md:w-[130px] md:h-[130px] object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </div>
          </div>

          {/* Bottom Right Clickable Area - Covers the entire right side bottom quarter */}
          <a 
            href="https://play.google.com/store/apps/details?id=com.farmnet.africa&pcampaignid=web_share" 
            target="_blank" 
            rel="noopener noreferrer"
            className="absolute bottom-0 right-0 w-[200px] h-1/4 z-40 cursor-pointer"
          >
            {/* Empty clickable area for Google Play Store */}
          </a>
          
          {/* "See More" Button that links to voiceoffarmer */}
          <div className="absolute md:bottom-4 bottom-2 right-2 md:right-4 z-50 flex items-center gap-2 group">
            <Link 
              to="/experiencemain" // Change this to your actual route
              className="md:w-[220px]  w-[80px] h-[15px]  md:h-[50px] flex items-center justify-center rounded-[2px] md:rounded-[8px] font-bold text-[6px] md:text-[20px] text-white shadow-xl"
          style={{
            background: "linear-gradient(90deg, #FDBB26 25%, #152C24 53%)",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
          }}
            >
               <span className="flex-1 text-center">Go To</span>
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756410811/Expand_right_1_bpdsxb.png"
            alt="arrow"
            className="md:w-[23px] w-[12px] h-[14px] md:h-[21px] mr-1 md:mr-4"
          />
            </Link>
          </div>
        </div>
      </div>

      {/* 3D Video Modal */}
      {showVideo && (
        <div 
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-sm"
          onClick={closeVideo}
        >
          <div
            ref={modalRef}
            className="relative w-[90vw] h-[70vh] md:w-[80vw] md:h-[80vh] bg-black rounded-xl overflow-hidden shadow-2xl transform transition-all duration-500 ease-out"
            style={{
              transform: 'scale(1) rotateY(0deg)',
              opacity: 1,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeVideo}
              className="absolute top-4 right-4 z-[110] text-white bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-100 transition-all duration-300"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            
            <div className="absolute inset-0 flex items-center justify-center bg-black">
              <video
                controls
                autoPlay
                className="w-full h-full object-contain"
                src={videoUrl}
              />
            </div>
            
            <div className="absolute inset-0 border-4 border-[#FDBD26] opacity-70 pointer-events-none"></div>
            <div className="absolute inset-0 border-8 border-[#2E453D] opacity-30 pointer-events-none"></div>
          </div>
        </div>
      )}

      <style jsx global>{`
        @keyframes modalOpen {
          0% {
            transform: scale(0.8) rotateY(90deg);
            opacity: 0;
          }
          100% {
            transform: scale(1) rotateY(0deg);
            opacity: 1;
          }
        }
        
        @keyframes modalClose {
          0% {
            transform: scale(1) rotateY(0deg);
            opacity: 1;
          }
          100% {
            transform: scale(0.8) rotateY(90deg);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default Solutions;